export const TYPOGRAPHIC_SCALE_FACTOR = 1.25
export const GET_SELECTION_BACKGROUND_COLOR = (alpha = 0.6) =>
  `rgba(140, 188, 248, ${alpha})`
